var React = require('react');

function IconLogoSimplifiedInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M67.3178 0H63.8018V7.00533V10.4946V34.9998H92.011V7.00533H67.3178V0ZM67.3178 10.4946H88.468V31.4837H67.3178V10.4946Z","fill":"white","key":0}),React.createElement("path",{"d":"M56.7156 7.00533H32.0225V34.9998H60.2316V10.4946V7.00533V0H56.7156V7.00533ZM56.7156 31.5106H35.5654V10.5214H56.7156V31.5106Z","fill":"white","key":1}),React.createElement("path",{"d":"M28.3967 7.05933H0.1875V10.6023H28.3967V7.05933Z","fill":"#23C865","key":2}),React.createElement("path",{"d":"M28.396 7.05933H24.9336V35.0001H28.396V7.05933Z","fill":"#23C865","key":3}),React.createElement("path",{"d":"M3.48924 7.05908H0V34.9999H3.48924V7.05908Z","fill":"#23C865","key":4})]);
}

IconLogoSimplifiedInline.defaultProps = {"width":"93","height":"35","viewBox":"0 0 93 35","fill":"none"};

module.exports = IconLogoSimplifiedInline;

IconLogoSimplifiedInline.default = IconLogoSimplifiedInline;
